import { render, staticRenderFns } from "./form-info.vue?vue&type=template&id=485a718c&scoped=true"
import script from "./form-info.vue?vue&type=script&lang=js"
export * from "./form-info.vue?vue&type=script&lang=js"
import style0 from "./form-info.vue?vue&type=style&index=0&id=485a718c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485a718c",
  null
  
)

export default component.exports